module.exports = __webpack_public_path__ + "static/media/home-g.af33c1e8.svg";